// src/utils/api/axios.js
import axios from "axios";
import { setCookie, getCookie, deleteCookie } from '../cookies/cookies.js';
import { IAM_PATH } from '../Config';

// 공통 axios 인스턴스 생성
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '', // 필요시 baseURL 지정
  timeout: 10000
});

// Request 인터셉터: 토큰 자동 추가
api.interceptors.request.use(
  function (config) {
    if (typeof config.url === 'string' && config.url.startsWith(IAM_PATH)) {
        config.withCredentials = true;
    }

    // 토큰 가져오는 방법: localStorage/sessionStorage/context 등
    const token = getCookie("accessToken"); // 예시: 세션 스토리지에서 가져옴
    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);


export default api;
